import { render } from "./Thread.vue?vue&type=template&id=67b233f5&scoped=true"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"

import "./Thread.vue?vue&type=style&index=0&id=67b233f5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b233f5"]])

export default __exports__